import { IBeneficialOwnershipTicketReportData } from 'components/Common/EntityTicketPdf';
import { didSecondLayerRun } from 'utils/beneficialOwnershipLayers';
import { buildOwnershipGraph } from 'utils/beneficialOwnershipGraph';

// The data the Beneficial Ownership PDF needs, read from a saved ticket. Saved
// Work and the entity record's Deep Dive both download the report from the
// same ticket, so they share this mapper.

const asArray = (value: any): any[] => (Array.isArray(value) ? value : []);

export const beneficialOwnershipWorkflowData = (ticket: any): any =>
  Array.isArray(ticket?.workflowData)
    ? ticket.workflowData[0] || {}
    : ticket?.workflowData || {};

export const beneficialOwnershipEntityName = (ticket: any): string =>
  beneficialOwnershipWorkflowData(ticket).entity_name ||
  ticket?.classificationValue ||
  ticket?.commodity?.commodityName ||
  ticket?.ticketName;

export const beneficialOwnershipCountry = (ticket: any): string =>
  beneficialOwnershipWorkflowData(ticket).country ||
  ticket?.commodity?.destinationCountry ||
  'Not provided';

export const buildBeneficialOwnershipReportData = (
  ticket: any,
  preparedBy: string,
): IBeneficialOwnershipTicketReportData => {
  const result =
    ticket?.beneficialOwnership ||
    beneficialOwnershipWorkflowData(ticket).result ||
    {};

  return {
    ticketName: ticket?.ticketName,
    entityName: beneficialOwnershipEntityName(ticket),
    country: beneficialOwnershipCountry(ticket),
    // Derived from the saved workflow state rather than the stored
    // boolean, so tickets saved with the wrong flag still export
    // correctly. See utils/beneficialOwnershipLayers.
    secondLayer: didSecondLayerRun(ticket),
    sanctionsFlag: result.sanctions_flag || '',
    sanctionsSummary: result.sanctions_summary || '',
    executiveSummary: result.executive_summary || '',
    summary:
      result.general_description ||
      result.summary ||
      result.beneficial_ownership_summary ||
      '',
    owners: asArray(result.owners),
    keyFindings: asArray(result.key_findings),
    associatedEntities: asArray(result.associated_entities),
    supportingLinks: asArray(result.supporting_links),
    ownershipGraph: buildOwnershipGraph(ticket),
    preparedBy: preparedBy,
  };
};
